export default "__VITE_ASSET__DKuPsWZJ__"